<template>
  <b-form @submit.prevent="submit" v-if="transactionData">
    <b-row>
      <b-col md="6">
        <b-form-group label="Klijent *">
          <search-client :focusable="true" tabindex="0" :disabled="transactionData.id !== null" v-model="transactionData.client"/>
          <app-validation-description :show="$v.transactionData.client.id.$dirty && $v.transactionData.client.id.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Datum *">
          <date-picker name="date" v-model="transactionData.date"/>
          <app-validation-description :show="$v.transactionData.date.$dirty && $v.transactionData.date.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="6" >
          <b-form-group label="Vrsta transakcija *">
            <b-select :options="type_options"
                      tabindex="1"
                      type="select"
                      ref="typeTransaction"
                      name="type"
                      v-model="transactionData.type">
            </b-select>
            <app-validation-description :show="$v.transactionData.type.$dirty && $v.transactionData.type.$invalid">
              {{$t('FIELD_MANDATORY')}}
            </app-validation-description>
          </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Iznos (KM) *">
          <app-decimal-input ref="amount" name="amount" v-model="transactionData.amount"/>
          <app-validation-description :show="$v.transactionData.amount.$dirty && $v.transactionData.amount.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="6" >
        <b-form-group label="Broj udjela *">
          <app-decimal-input :decimals="6" name="number_of_quota" v-model="transactionData.number_of_quota"/>
          <app-validation-description :show="$v.transactionData.number_of_quota.$dirty && $v.transactionData.number_of_quota.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="6" >
        <b-form-group label="Cijena udjela (KM) *">
          <app-decimal-input :decimals="4" name="price_of_quota" v-model="transactionData.price_of_quota"/>
          <app-validation-description :show="$v.transactionData.price_of_quota.$dirty && $v.transactionData.price_of_quota.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="6" v-if="Number(transactionData.type) === 2">
        <b-form-group label="Trošak izlazne naknade(KM) *" >
          <app-decimal-input tabindex="-1" :decimals="2" name="output_fee" v-model="transactionData.output_fee"/>
          <app-validation-description  :show="$v.transactionData.output_fee.$dirty && $v.transactionData.output_fee.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="6" >
        <b-form-group label="Stanje udjela *">
          <app-decimal-input :decimals="6" name="sum_quota" v-model="transactionData.sum_quota"/>
          <app-validation-description :show="$v.transactionData.sum_quota.$dirty && $v.transactionData.sum_quota.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
      <b-col  md="6" >
        <b-form-group label="Broj zahtjeva *">
          <b-form-input
            type="text"
            v-model="transactionData.number_of_request"
            name="number_of_request">
          </b-form-input>
          <app-validation-description :show="$v.transactionData.number_of_request.$dirty && $v.transactionData.number_of_request.$invalid">
            {{$t('FIELD_MANDATORY')}}
          </app-validation-description>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col>
        <submit :loading="loading"></submit>
      </b-col>
      <b-col v-if="transactionData.id">
        <delete-button
                       @click="showDeleteDialog=true"
                       class="pull-right">
        </delete-button>

        <app-confirmation-dialog :show="showDeleteDialog" @confirm="deleteTransaction" @cancel="showDeleteDialog=false"> </app-confirmation-dialog>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import DeleteButton from '@/components/app/AppDelete'
import Submit from '@/components/app/AppSubmit'
import DatePicker from '@/components/app/datetime/DatePicker'
import AppValidationDescription from "@/components/app/form/AppValidationDescription";
import { required } from 'vuelidate/lib/validators'
import {toast} from "@/shared/plugins/toastr";
import {createTransaction, deleteTransaction, updateTransaction} from "@/services/transaction";
import {getClientList} from "@/services/client";
import {getErrorMessage} from "@/mixins/error/getErrorMessage";
import {cloneDeep} from "lodash";
import AppConfirmationDialog from "@/components/app/form/AppConfirmationDialog";
import AppDecimalInput from "@/components/app/AppDecimalInput";
import SearchClient from "@/components/client/SearchClient";

export default {
  name: "TransactionForm",
  props: {
    transactionObject: {
      type: Object,
    }
  },
  data() {
    return {
      transactionData: {
        id: null,
        client: {
          id: null,
          name: null
        },
        date: null,
        type: null,
        amount: null,
        number_of_quota: null,
        price_of_quota: null,
        output_fee: null,
        sum_quota: null,
        number_of_request: null,
      },
      type_options: [
        {value: null, text: '-'},
        { value: 1, text: 'Kupovina' },
        { value: 2, text: 'Prodaja' },
      ],
      loading: false,
      clients: [],
      showDeleteDialog: false,
    };
  },
  mixins:[getErrorMessage],
  validations() {
    return Number(this.transactionData.type) === 1 ? {
      transactionData:{
        client: {
          id: { required }
        },
        date: { required },
        type: { required },
        amount: { required },
        number_of_quota: { required },
        price_of_quota: { required },
        sum_quota: { required },
        number_of_request: { required }
      }
    } : {
      transactionData: {
        client: {
          id: {required}
        },
        date: {required},
        type: {required},
        amount: {required},
        number_of_quota: {required},
        price_of_quota: {required},
        sum_quota: {required},
        number_of_request: {required},
        output_fee: { required },
      }
    }
  },
  components: {
    AppDecimalInput,
    AppConfirmationDialog,
    AppValidationDescription,
    Submit,
    DatePicker,
    DeleteButton,
    SearchClient
  },
  methods: {

    deleteTransaction() {
      deleteTransaction(this.transactionData.id).then(() => {
        toast({
          'title': this.$t('NOTIFICATIONS.DELETE_SUCCESS.MESSAGE'),
          'type': 'success',
          'timeout': 2000
        })
        this.$emit('success')
      }, (error) => {
        toast({
          'title': "Delete  fail",
          'message': this.getMessages(error),
          'type': 'error',
          'timeout': 6000
        })
      }).finally(()=> {
        this.loading = false;
      })
    },
    submit() {
      this.$v.transactionData.$touch()
      if(this.$v.transactionData.$invalid){
        toast({
          'title': this.$t('VALIDATION_FAILED'),
          'message': null,
          'type': 'error',
          'timeout': 6000
        })
        return
      }
      this.loading = true;
      if(this.transactionData.id) {
        const request = {
          id: this.transactionData.id,
          client_id: this.transactionData.client.id,
          date: this.transactionData.date,
          type: this.transactionData.type,
          amount: this.transactionData.amount,
          number_of_quota: this.transactionData.number_of_quota,
          price_of_quota: this.transactionData.price_of_quota,
          output_fee: this.transactionData.output_fee,
          sum_quota: this.transactionData.sum_quota,
          number_of_request: this.transactionData.number_of_request,
        }
        updateTransaction(this.transactionData.id, request).then(() => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
            'type': 'success',
            'timeout': 2000
          })
          this.$emit('success')
        }, (error) => {
          toast({
            'title': "Save  fail",
            'message': this.getMessages(error),
            'type': 'error',
            'timeout': 6000
          })
        }).finally(()=> {
          this.loading = false;
        })
      } else {
        const request = {
          client_id: this.transactionData.client.id,
          date: this.transactionData.date,
          type: this.transactionData.type,
          amount: this.transactionData.amount,
          number_of_quota: this.transactionData.number_of_quota,
          price_of_quota: this.transactionData.price_of_quota,
          output_fee: this.transactionData.output_fee,
          sum_quota: this.transactionData.sum_quota,
          number_of_request: this.transactionData.number_of_request,
        }
        createTransaction(request).then(() => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
            'type': 'success',
            'timeout': 2000
          })
          this.$emit('success')
        }, (error) => {
          toast({
            'title': "Save  fail",
            'message': this.getMessages(error),
            'type': 'error',
            'timeout': 6000
          })
        }).finally(()=> {
          this.loading = false;
        })
      }
    }
  },
  watch: {
    'transactionData.type': {
      handler() {
        this.$refs.amount.$el.focus()
      }
    }
  },
  async mounted() {
    if(this.transactionObject) {
      this.transactionData = cloneDeep(this.transactionObject)
    }
  }
}
</script>

<style scoped>

</style>
